import Vue from 'vue';
import Slick from 'vue-slick';

import ListingProductItem from '../components/featured-products-slider.vue';

function initVueInstance(element) {
    new Vue({
        el: element,

        delimiters: ['${', '}'],

        components: {
            Slick,
            ListingProductItem
        },

        data: {
            slickOptions: {
                slidesToShow: 5,
                arrows: true,
                dots: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        infinite: false
                    }
                }]
            }
        }
    });
}
const selectFeaturedCollection = () => document.querySelectorAll('[vue-init-featured-collection]').forEach(element => {
    initVueInstance(element);
});
selectFeaturedCollection();

document.addEventListener("shopify:section:load", function() {
    selectFeaturedCollection();
});

